// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"89645d3b","455":"722e2c96","977":"ad121c5c"}[chunkId] + ".chunk.js";
};